<template>
  <div class="container-fluid card multi-unit-container">
    <div><span class="x-button" v-on:click="$emit('clear-unit-addresses')">X</span></div>
    <div class="row">
      <div v-for="(column, columnIndex) in numberColumns" v-bind:key="columnIndex" class="col">
        <home-card
          v-for="(house, index) in unitDataSubset"
          v-if="index % numberColumns == columnIndex"
          class="no-top-margin"
          v-bind:key="house._id"
          v-bind:searchString="searchString"
          v-bind:data="house"
          v-on:mouseover.native="$emit('mouse-over', house._id)"
          v-on:mouseout.native="$emit('mouse-out', house._id)"
          v-on:login-required="loginRequired"></home-card>
      </div>
    </div>
    <auth-modal ref="authModal"></auth-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthModal from '../../../authentication/TheAuthModal.vue'
import AWS from 'aws-sdk/global'
import AWSConnector from 'http-aws-es'
import elasticsearch from 'elasticsearch'
import homeCard from './HomeCard.vue'
const cardBatchIncrement = 25

export default {
  data () {
    return {
      numberOfCardsToDisplay: cardBatchIncrement,
      unitData: [],
      windowWidth: 0
    }
  },
  components: {
    'home-card': homeCard,
    AuthModal
  },
  props: {
    unitAddresses: Array
  },
  computed: {
    ...mapGetters([
      'getAccessKeyId',
      'getSecretAccessKey',
      'getSessionToken'
    ]),
    searchString () {
      return this.$route.query.search
    },
    unitDataSubset () {
      return this.unitData.slice(0, this.numberOfCardsToDisplay)
    },
    numberColumns () {
      if (this.windowWidth <= 1300) {
        return 1
      } else if (this.windowWidth <= 2000) {
        return 2
      }
      return 3
    }
  },
  methods: {
    loginRequired () {
      this.$refs.authModal.$refs.authModal.show()
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
    loadMoreResults () {
      if (this.numberOfCardsToDisplay <= this.unitData.length) {
        this.numberOfCardsToDisplay += cardBatchIncrement
      }
    },
    async performSearch () {
      if (!this.getSecretAccessKey || !this.getAccessKeyId) return
      AWS.config.update({
        credentials: new AWS.Credentials(this.getAccessKeyId, this.getSecretAccessKey, this.getSessionToken),
        region: window.CONFIG.Region
      })
      try {
        var client = new elasticsearch.Client({
          connectionClass: AWSConnector,
          host: window.CONFIG.SearchDomain,
          apiVersion: '6.4'
        })
        let body = []
        this.unitAddresses.map(function (addressInfo) {
          // Header required - blank will utilize default settings
          body.push({})

          // Search request
          let conditions = []
          if (addressInfo.street_number) { conditions.push({match: {street_number: {query: addressInfo.street_number, boost: 2}}}) }
          if (addressInfo.street_name) { conditions.push({match: {street_name: {query: addressInfo.street_name, boost: 5}}}) }
          if (addressInfo.street_suffix) { conditions.push({match: {street_suffix: addressInfo.street_suffix}}) }
          if (addressInfo.street_dir) { conditions.push({match: {street_dir: addressInfo.street_dir}}) }
          if (addressInfo.city) { conditions.push({match: {city: {query: addressInfo.city, boost: 5}}}) }
          if (addressInfo.state) { conditions.push({match: {state: addressInfo.state}}) }
          if (addressInfo.zip_code) { conditions.push({match: {zip_code: {query: addressInfo.zip_code, boost: 5}}}) }
          body.push({
            _source: ['photos', 'price', 'bedroom_count', 'bathroom_count', 'unit_number', 'street_number', 'street_name', 'street_suffix', 'street_dir', 'city', 'state', 'zip_code', 'brokerage'],
            size: 2000,
            query: {
              bool: {
                must: conditions
              }
            }
          })
        })
        const results = await client.msearch({
          index: 'house',
          type: '_doc',
          body: body
        })
        this.unitData = results.responses.map(responseObj => responseObj.hits.hits).flat()
        this.unitData.forEach((unit) => {
          if (unit._source.photos) unit._source.photos.sort()
        })
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted () {
    this.performSearch()
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.card {
  padding: 1rem;
  border-radius: 10px;
  margin: .7rem;
  cursor: pointer;
}

.multi-unit-container {
  background-color: #add8e6;
  cursor: auto;
  padding-top: 0.5rem;
  margin-top: 0;
}

.no-top-margin {
  margin-top: 0;
}

.row {
  margin-right: 1rem;
  margin-left: .1rem;
}

.x-button {
  color: black;
  cursor: pointer;
  float: right;
  font-weight: 900;
  font-size: 1.5rem;
  width: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/rightSide/MultiUnitData.vue